import { map } from 'lodash'
import bus from '@/utils/eventBus'
import { error } from '@/utils/alert'

export default {
  doConfirmedAll () {
    const ids = map(this.schedules, schedule => {
      return schedule.id
    })

    this.$resource.put(ids.toString() + '/in-attendance')
      .then(({data}) => {
        bus.$emit('is-attendance', {show: true})
        this.$emit('close', data)
      })
      .catch(() => {
        error('Ocorreu um erro ao definido como agendado.')
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/schedulings/index/components/in-attendance/resources/methods.js